function ActiveRecord(type, item) {
  this._type=type;
  for(var field in item || {})
    this[field]=item[field];
}
ActiveRecord.prototype.parseFields=function(showFields) {
  var showFieldsLen=showFields.length;
  var tokens=[];
  var lastTokenType=null;
  for(var i=0;i<showFieldsLen;i++) {
    var char=showFields[i];
    var charCode=showFields.charCodeAt(i);
    var incl=(charCode>=65 && charCode<=90) ||
              (charCode>=97 && charCode<=122) ||
              ["_", "-","*","{","}",","].indexOf(char)!=-1;
    if (!incl)
      continue;
    if (lastTokenType!="identifier") {
      tokens.push(char);
      lastTokenType="other";
      if ((charCode>=65 && charCode<=90) ||
          (charCode>=97 && charCode<=122) ||
          ["_", "-","*"].indexOf(char)!=-1)
        lastTokenType="identifier";
    } else if (lastTokenType=="identifier") {
      if ((charCode>=65 && charCode<=90) ||
          (charCode>=97 && charCode<=122) ||
          ["_", "-","*"].indexOf(char)!=-1)
        tokens[tokens.length-1]+=char;
      else {
        tokens.push(char);
        lastTokenType="other";
      }
    }
  }
  while(tokens.length>1) {
    var lastCount=tokens.length;
    var lastOpen=null;
    for(var i in tokens) {
      var token=tokens[i];
      if (Array.isArray(token))
        continue;
      if (token=="{")
        lastOpen=i;
      if (token=="}") {
        if (lastOpen===null)
          return null;
        var inner=tokens.slice(lastOpen*1+1, i*1).filter(item=>item!=",");
        var newInner=[];
        for(var innerItem of inner) {
          if (typeof(innerItem)=="string")
            newInner.push({field: innerItem});
          else if (newInner.length)
            newInner[newInner.length-1].sub=innerItem;
        }
        tokens.splice(lastOpen*1, i-lastOpen+1, newInner);
        break;
      }
    }
    if (tokens.length>=lastCount)
      break;
  }
  return tokens[0] || null;
}
ActiveRecord.prototype.filterFields=function (data, fields) {
  var result={};
  if (typeof(fields)=="string")
    fields=this.parseFields(fields);
  if (!fields)
    return data;
  for(var field in data) {
    var value=data[field];
    if (field=="id" || field=="uuid") {
      result[field]=value;
      continue;
    }
    var fieldDesc=fields.find(item=>item.field==field);
    if (!fieldDesc)
      continue;
    if (typeof(value)!="object" || !fieldDesc.sub)
      result[field]=value;
    else if (Array.isArray(value)) {
      result[field]=value.map(item=>this.filterFields(item, fieldDesc.sub));
    } else {
      result[field]=this.filterFields(value, fieldDesc.sub);
    }
  }
  return result;
}
ActiveRecord.prototype.save=async function(fields) {
  var blacklist=["_type", "id", "uuid"];
  var data={};
  for(var i in this) {
    if (blacklist.indexOf(i)==-1)
      data[i]=this[i];
  }
  if (fields)
    data=this.filterFields(data, fields);
  var result;
  if (this.uuid) {
    result=await api.doUpdate(this._type, this.uuid, data);
  } else {
    result=await api.doCreate(this._type, data);
  }
  if (result?.body?.id)
    this.id=result.body.id;
  if (result?.body?.uuid)
    this.uuid=result.body.uuid;
  return result;
}
ActiveRecord.prototype.delete=async function() {
  if (this.id)
    return await api.doDelete(this._type, this.id);
}

var api={
  auth: localStorage.getItem("icommerce-pub-auth-token", null),
  setAuth(token) {
    if (token)
      localStorage.setItem("icommerce-pub-auth-token", token);
    else
      localStorage.removeItem("icommerce-pub-auth-token");
    this.auth=token;
  },
  objQuery(data, path) {
    var result=[];
    path=path || [];
    for(var key in data) {
      if (Array.isArray(data[key])) {
        result=[...result, ...this.objQuery(data[key], [...path, key])];
      } else if (typeof(data[key])=="object") {
        result=[...result, ...this.objQuery(data[key], [...path, key])];
      } else {
        var actualKey=[...path, key].map((el,index)=>index?'['+el+']':el).join("");
        result.push([actualKey, data[key]]);
      }
    }
    return result;
  },
  async request(method, path, data) {
    if (method=="GET" && data) {
      path+="?"+(new URLSearchParams(this.objQuery(data)).toString());
    }
    try {
      var req=await fetch(appEnv.pubApiRoot+path, {
        method,
        headers: {
          ...(method!="GET" && method!="DELETE"?{"Content-Type": "application/json"}:{}),
          ...(this.auth?{"Authorization": "Bearer "+this.auth}:{})
        },
        cache: 'no-cache',
        ...(method!="GET" && method!="DELETE"?{body: JSON.stringify(data)}:{}),
      });
      try {
        var body=await req.text();
        if (req.ok) {
          var jsonBody=JSON.parse(body);
          if (jsonBody?.apiLog?.length)
            api.apiLog(jsonBody.apiLog);
          return jsonBody;
        } else
          return {...JSON.parse(body), status: req.status};
      } catch(e) {
        return {status: req.status, error: body};
      }
    } catch(e) {
      return {error: 'network'};
    }
  },
  async upload(path, file, field) {
    try {
      var formData=new FormData();
      formData.append("file", file);
      if (field)
        formData.append("field", field);
      var req=await fetch(appEnv.pubApiRoot+path, {
        method: "POST",
//         headers: {
//           "Content-Type": "multipart/form-data",
//         },
        cache: 'no-cache',
        body: formData,
      });
      try {
        var body=await req.text();
        if (req.ok)
          return JSON.parse(body);
        else
          return {...JSON.parse(body), status: req.status};
      } catch(e) {
        return {status: req.status, error: body};
      }
    } catch(e) {
      console.log(e);
      return {error: 'network'};
    }
  },
  async list(path, where, fields, sort, limit, start, getCount) {
    var args={};
    if (where)
      args.q=where;
    if (fields)
      args.g=fields;
    if (sort)
      args.o=sort.join(",");
    if (limit)
      args.l=limit;
    if (start)
      args.s=start;
    var result=(await this.request("GET", path, args));
    if (getCount)
      return {count: result.count, items: (result.body || []).map(
      (item)=>new ActiveRecord(path, item))};
    return (result.body || []).map(
      (item)=>new ActiveRecord(path, item));
  },
  async root() {
    return await this.request("GET", "");
  },
  async login(username, authdata) {
    return await this.request("POST", "_login", {username, authdata});
  },
  async get(path, id, fields) {
    var extra=fields?"?g="+encodeURIComponent(fields):"";
    var item=(await this.request("GET", path+(id?"/"+id:"")+extra)).body;
    if (item)
      return new ActiveRecord(path, item);
    return null;
  },
  create(path, data) {
    return new ActiveRecord(path, data);
  },
  async doDelete(path, id) {
    return await this.request("DELETE", path+(id?"/"+id:""));
  },
  async doUpdate(path, id, data) {
    return await this.request("PUT", path+(id?"/"+id:""), {...data});
  },
  async doAction(path, id, data) {
    return await this.request("POST", path+(id?"/"+id:""), {...data});
  },
  async doCreate(path, data) {
    return await this.request("POST", path, {...data});
  },
  apiLog(logItems) {
    var logList=document.querySelector("#debug-api-log>ul");
    if (logList)
      for(var item of logItems) {
        var li=document.createElement("li");
        var pre=document.createElement("pre");
        pre.innerText=`${item.method} ${item.url} ${JSON.stringify(item.data)}`;
        li.appendChild(pre);
        logList.appendChild(li);
      }
  },
}


export default api;
